import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SoundService } from '@org/shared-services';

@Component({
  selector: 'app-sound-permission-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 transform transition-all">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-medium text-gray-900">Notification Sounds</h3>
            <button (click)="onClose()" class="text-gray-400 hover:text-gray-500">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <!-- Content -->
        <div class="px-6 py-4">
          <div class="flex items-start space-x-4">
            <div class="flex-shrink-0">
              <mat-icon class="text-indigo-600 text-2xl">notifications_active</mat-icon>
            </div>
            <div class="flex-1">
              <p class="text-sm text-gray-600">
                Would you like to enable notification sounds? This will help you stay informed about new tasks and updates in real-time.
              </p>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-end space-x-3">
          <button
            (click)="onMaybeLater()"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Maybe Later
          </button>
          <button
            (click)="onEnableSounds()"
            class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Enable Sounds
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class SoundPermissionModalComponent {
  constructor(
    private dialogRef: MatDialogRef<SoundPermissionModalComponent>,
    private soundService: SoundService
  ) {}

  onEnableSounds(): void {
    this.soundService.setPermission(true);
    this.dialogRef.close(true);
  }

  onMaybeLater(): void {
    this.soundService.setPermission(false);
    this.dialogRef.close(false);
  }

  onClose(): void {
    // When using the X button, treat it as "Maybe Later"
    this.onMaybeLater();
  }
} 